import React, { useState } from 'react';
import { ScheduleExpression } from '@glueapp/graph-types';
import { RateInput } from './RateInput';
import { OneTimeInput } from './OneTimeInput';
import { CronInput } from './CronInput';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';

interface ScheduleEditorProps {
    value: ScheduleExpression;
    onChange: (updatedSchedule: ScheduleExpression) => void;
}

export const ScheduleInput: React.FC<ScheduleEditorProps> = ({ value, onChange }) => {
    const [editedSchedule, setEditedSchedule] = useState<ScheduleExpression>(value);

    const handleTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newType = event.target.value;
        if (newType === 'OneTimeSchedule') {
            setEditedSchedule({ type: 'OneTimeSchedule', dateTime: '' });
        } else if (newType === 'RecurringRateBasedSchedule') {
            setEditedSchedule({ type: 'RecurringRateBasedSchedule', unit: 'DAY', value: 1 });
        } else if (newType === 'RecurringCronBasedSchedule') {
            setEditedSchedule({ type: 'RecurringCronBasedSchedule', cronExpression: '* * * * *' });
        }
    };

    const submit = () => {
        onChange(editedSchedule);
    };

    const renderInputs = () => {
        switch (editedSchedule.type) {
            case 'OneTimeSchedule':
                return <OneTimeInput value={editedSchedule} onChange={setEditedSchedule} />;
            case 'RecurringRateBasedSchedule':
                return <RateInput value={editedSchedule} onChange={setEditedSchedule} />;
            case 'RecurringCronBasedSchedule':
                return <CronInput value={editedSchedule} onChange={setEditedSchedule} />;
        }
    };

    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-1.5">
                <Label className="text-xs">Mode</Label>
                <Select
                    value={editedSchedule.type}
                    onValueChange={value => handleTypeChange({ target: { value } } as React.ChangeEvent<HTMLSelectElement>)}
                >
                    <SelectTrigger>
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="OneTimeSchedule">Once</SelectItem>
                        <SelectItem value="RecurringRateBasedSchedule">Rate</SelectItem>
                        <SelectItem value="RecurringCronBasedSchedule">Cron Format</SelectItem>
                    </SelectContent>
                </Select>
            </div>
            {renderInputs()}
            <Button size="sm" onClick={submit}>
                Update Schedule
            </Button>
        </div>
    );
};
